export default [
    {
        path: '/_whatsapp',
        name: 'whatsapp|scan',
        component: () => import('@/views/whatsapp/scan.vue')
    },
    {
        path: '/_whatsapp/device',
        name: 'whatsapp|device',
        component: () => import('@/views/whatsapp/device.vue')
    },
    {
        path: '/_whatsapp/archive',
        name: 'whatsapp|archive',
        component: () => import('@/views/whatsapp/archive.vue')
    },
    {
        path: '/_whatsapp/api',
        name: 'whatsapp|api',
        component: () => import('@/views/whatsapp/api.vue')
    },
    {
        // «واتساب ميتا»: the official messages (Meta) through MAX
        path: '/_whatsapp/meta',
        name: 'whatsapp|meta',
        component: () => import('@/views/whatsapp/meta.vue')
    },
]
